'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _shift = require('unmutable/lib/shift');

var _shift2 = _interopRequireDefault(_shift);

var _update = require('unmutable/lib/update');

var _update2 = _interopRequireDefault(_update);

var _pipe = require('unmutable/lib/util/pipe');

var _pipe2 = _interopRequireDefault(_pipe);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
    var fn = (0, _shift2.default)();
    return (0, _pipe2.default)((0, _update2.default)('value', fn), (0, _update2.default)('child', fn));
};


//////////////////
// WEBPACK FOOTER
// ./~/parcels/lib/parcelData/shift.js
// module id = 754
// module chunks = 35783957827783